"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryStringParser = void 0;
var userdefined_1 = require("../../interfaces/userdefined");
var QueryStringParser = (function () {
    function QueryStringParser(query_string) {
        this.url_base = new URLSearchParams(query_string);
    }
    QueryStringParser.prototype.clone = function () {
        return new QueryStringParser(this.toString());
    };
    QueryStringParser.prototype.reset = function () {
        this.url_base = new URLSearchParams();
    };
    QueryStringParser.prototype.set = function (field_name, value) {
        if (Array.isArray(value)) {
            this.setAll(field_name, value);
        }
        else {
            this.url_base.set(field_name, value);
        }
    };
    QueryStringParser.prototype.setAll = function (field_name, values) {
        var _this = this;
        values.forEach(function (value) { return _this.append(field_name, value); });
    };
    QueryStringParser.prototype.append = function (field_name, value) {
        this.url_base.append(field_name, value);
    };
    QueryStringParser.prototype.clean = function () {
        var _this = this;
        this.get_names().forEach(function (name) {
            var value = _this.get(name);
            if (value == null || value === "NaN" || value === "" || value === "null") {
                _this.url_base.delete(name);
            }
        });
    };
    QueryStringParser.prototype.toString = function () {
        this.clean();
        return this.url_base.toString();
    };
    QueryStringParser.prototype.get = function (field_name) {
        return this.url_base.get(field_name);
    };
    QueryStringParser.prototype.getAll = function (field_name) {
        return this.url_base.getAll(field_name);
    };
    QueryStringParser.prototype.get_names = function () {
        var field_names = [];
        var iter = this.url_base.keys();
        var result = iter.next();
        while (!result.done) {
            field_names.push(result.value);
            result = iter.next();
        }
        field_names = field_names.filter(function (name, index) {
            return field_names.indexOf(name) === index;
        });
        return field_names;
    };
    QueryStringParser.prototype.reset_from_state = function (state_data) {
        this.reset();
        for (var field_name in state_data) {
            if (!state_data.hasOwnProperty(field_name))
                continue;
            var value = state_data[field_name];
            if ((field_name == "qs") || value === "" || value === null)
                continue;
            if (state_data[field_name] instanceof Array) {
                if (state_data[field_name].length > 0 && (0, userdefined_1.isUDFValue)(state_data[field_name][0])) {
                    this.set_udf_fields(state_data[field_name]);
                }
                else {
                    this.setAll(field_name, state_data[field_name]);
                }
            }
            else {
                this.set(field_name, state_data[field_name]);
            }
        }
    };
    QueryStringParser.prototype.get_value_count = function () {
        var iter = this.url_base.values();
        var counter = 0;
        var result = iter.next();
        while (!result.done) {
            if (result.value)
                counter++;
            result = iter.next();
        }
        return counter;
    };
    QueryStringParser.prototype.get_key_count = function () {
        var _this = this;
        var names = this.get_names();
        return names.reduce(function (key_counter, name) {
            if (_this.get(name) && _this.get(name) != 'false')
                key_counter++;
            return key_counter;
        }, 0);
    };
    QueryStringParser.prototype.get_key_count_for = function (key_names) {
        var _this = this;
        return this.get_names().reduce(function (count, name) {
            if (key_names.indexOf(name) != -1 && _this.get(name)
                && _this.get(name) != 'false')
                count++;
            return count;
        }, 0);
    };
    QueryStringParser.prototype.get_udf_key_count = function () {
        var _this = this;
        return this.get_udf_field_names().reduce(function (count, name) {
            if (_this.get(name) && _this.get(name) != 'false')
                count++;
            return count;
        }, 0);
    };
    QueryStringParser.prototype.set_udf_fields = function (values) {
        var _this = this;
        values.forEach(function (value) {
            _this.append((0, userdefined_1.get_field_basic_uid)(value.field_type), value.value);
        });
    };
    QueryStringParser.prototype.get_udf_field_values = function (udf_type) {
        var field_name = (0, userdefined_1.get_field_basic_uid)(udf_type);
        var values = this.getAll(field_name);
        return values.map(function (value) {
            return {
                id: undefined,
                field_type: {
                    id: parseInt(field_name.split("_")[1]),
                    name: field_name,
                    is_active: true,
                    type_id: undefined,
                    object_type: undefined,
                    options: undefined,
                    target_type: undefined
                },
                value: value,
                target_type: undefined,
                target_object_id: undefined
            };
        });
    };
    QueryStringParser.prototype.get_udf_field_names = function () {
        return this.get_names().filter(function (name) { return name.indexOf('udf_') == 0; });
    };
    QueryStringParser.prototype.get_udf_fields = function () {
        var _this = this;
        var udf_field_values = [];
        var udf_field_names = this.get_udf_field_names();
        udf_field_names.forEach(function (udf_name) {
            var udf_values = _this.getAll(udf_name);
            udf_values.forEach(function (udf_value) {
                udf_field_values.push({
                    id: undefined,
                    field_type: {
                        id: parseInt(udf_name.split("_")[1]),
                        name: udf_name,
                        is_active: true,
                        type_id: undefined,
                        object_type: undefined,
                        options: undefined,
                        target_type: undefined
                    },
                    value: udf_value,
                    target_type: undefined,
                    target_object_id: undefined
                });
            });
        });
        return udf_field_values;
    };
    QueryStringParser.prototype.to_object = function () {
        var _this = this;
        this.clean();
        var obj = {};
        this.get_names().forEach(function (name) {
            obj[name] = _this.getAll(name);
        });
        return obj;
    };
    QueryStringParser.prototype.to_json = function () {
        return JSON.stringify(this.to_object());
    };
    return QueryStringParser;
}());
exports.QueryStringParser = QueryStringParser;
